import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: `'Noto Sans JP', sans-serif`,
  },
  zIndex: {
    // MUI標準のz-index
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
    // カスタムz-index
    propertyName: 99,
    propertyTabs: 100,
  },
});

export default theme;
